/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Compax Frontend API-v2
 * API by Compax
 * OpenAPI spec version: 161.0.0-SNAPSHOT
 */

export type SimCardDetailSimStatus =
  (typeof SimCardDetailSimStatus)[keyof typeof SimCardDetailSimStatus];

export const SimCardDetailSimStatus = {
  green: "green",
  yellow: "yellow",
  grey: "grey",
  red: "red",
  orange: "orange",
} as const;
